import {Injectable} from '@angular/core';
import {ApiService} from '@core/services/api.service';

export interface IParamsLogExportExcel {
  businessId: number,
  type: number,
  totalRows: number,
  link: string, // URI QUERY
}

@Injectable({
  providedIn: 'any'
})
export class LoggingService extends ApiService {
  saveLogExportExcel(params: IParamsLogExportExcel) {
    return this.postRequest('/logging/index/savelogexportexcel', params);
  }
}
